import dayjs from 'dayjs'
import { useEffect, useReducer } from 'react'
import { SelectedDateContext, SelectedDateDispatchContext } from './context'
import { selectedDateReducer } from './reducer'

export function SelectedDateProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [selectedDate, dispatch] = useReducer(selectedDateReducer, {
    activePeriod: 'day',
    date: dayjs(),
    week: dayjs().week(),
    year: dayjs().year(),
  })

  // keyboard shortcuts
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      let direction = 0

      if (event.metaKey && event.ctrlKey) {
        // handle Ctrl+CMD+Left/Right to switch days
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          direction = event.key === 'ArrowLeft' ? -1 : 1
        }

        // handle Ctrl+CMD+Up/Down to switch weeks
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          direction = event.key === 'ArrowUp' ? -7 : 7
        }

        if (direction !== 0) {
          event.preventDefault()
          dispatch({ type: 'shift', direction })
          event.stopPropagation()
        }
      }

      // handle Ctrl+T to switch to today
      if (event.key === 't' && event.ctrlKey) {
        event.preventDefault()
        dispatch({ type: 'today', forceDay: true })
        // Dispatch custom event to navigate to daily note, otherwise this won't work if we are inside a regular note
        window.dispatchEvent(new CustomEvent('navigateToDaily'))
        event.stopPropagation()
      }
    }
    document.addEventListener('keydown', handleKeyDown)

    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [dispatch])

  return (
    <SelectedDateContext.Provider value={selectedDate}>
      <SelectedDateDispatchContext.Provider value={dispatch}>
        {children}
      </SelectedDateDispatchContext.Provider>
    </SelectedDateContext.Provider>
  )
}
